import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { RecentPostsTitle } from '../../../../../Utils/Constants'
import { H6, Image, LI, P, UL } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Utils'
import { recentPostsData } from '../../../../../Data/Miscellaneous/Blog'

export default function RecentPosts() {
    return (
        <Col sm={12}>
            <Card>
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={RecentPostsTitle} />
                <CardBody>
                    <UL className="recent-blog simple-list">
                        {recentPostsData.map((item) => (
                            <LI key={item.id}>
                                <div className="d-flex gap-2 align-items-start">
                                    <Image className="img-fluid rounded" src={dynamicImage(`blog/small/${item.image}`)} alt="Generic placeholder image" />
                                    <div className="flex-grow-1">
                                        <H6>{item.title}</H6>
                                        <P>{item.time}</P>
                                    </div>
                                </div>
                            </LI>
                        ))}
                    </UL>
                </CardBody>
            </Card>
        </Col>
    )
}